// extracted by mini-css-extract-plugin
module.exports = {"select-merchant":"_2L5OipwH1b","logo":"_2EpcgGnTwf","container":"_1fjdN_IBab","title":"m6xcLL6K5W","merchant-box":"_39h90VBJ1B","merchant-item":"_2q7VYgF8Ty"};